import type {SyncIntegration} from '@cohort/merchants/apps';
import ComarchSyncConfigComponent from '@cohort/merchants/apps/comarch/sync/SyncConfigComponent';
import type {ComarchSyncStruct} from '@cohort/shared/apps/comarch/sync';
import {ComarchSyncSpec} from '@cohort/shared/apps/comarch/sync';

export const ComarchSyncIntegration: SyncIntegration<ComarchSyncStruct> = {
  spec: ComarchSyncSpec,
  syncConfigComponent: ComarchSyncConfigComponent,
};
